module.exports = __webpack_public_path__ + "media/images/pro_subscription/carousel3-childcare-fr-FR@2x-53923a8f9fd4998cc330f69ff688f876.png";